/* eslint-disable array-callback-return */
import { FC, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Modal } from 'components';
import { arrowLeft } from 'assets';
import { Col, Row, Typography, Menu, Spin } from 'antd';
import { Bar } from 'react-chartjs-2';
import { Chart, ChartData, ChartOptions, registerables } from 'chart.js';
import { CSVLink } from 'react-csv';
import { CooperatorsUserItem, GetUserHealthResponse, SchedulesDate } from 'types';
import moment from 'moment';
import { workerService } from 'services';
import { dayjs } from 'libs';
import lodash from 'lodash';
import isBetween from 'dayjs/plugin/isBetween';
import { ChartContentStyled, ButtonCsv, HeaderStyledChart, ModalStyle, RowText } from './styles';

dayjs.extend(isBetween);

Chart.register(...registerables);
type tableDataType = {
  cooperator_company_name: string;
  cooperator_id: number;
  user_id: number;
  user_name: string;
  work_type_id: number;
  work_type_name: string;
  start_date: string;
  first_date: string;
  end_date: string;
  // 2024/01/02 Leading Win 教育機能対応 DXWEBWIN00100_作業員情報 startv
  insurance_status: number;
  medical_status: number;
  // 2025/02/11 FJ 3月分反映分 NO58 start
  // newcomer_education_status: number;
  // sendoff_education_status: number;
  // 2025/02/11 FJ 3月分反映分 NO58 end
  // 2024/01/02 Leading Win 教育機能対応 DXWEBWIN00100_作業員情報 end
};

type dataCsvProps = {
  date: { date: string };
  user_name: string;
  work_type_name: string;
  cooperator_company_name: string;
  enter_time: string;
  leave_time: string;
  // 2025/04/30 Leading Win 匠対応一覧#17 start
  // body_temperature: number;
  // blood_pressure_min: number;
  // blood_pressure_max: number;
  // heartbeat_count: string[];
  // score: string;
  // steps: string[];
  // 2025/04/30 Leading Win 匠対応一覧#17 end
};

interface Props {
  visible: boolean;
  closeVisible: (close: boolean) => void;
  record?: tableDataType;
  schedules: SchedulesDate[];
}

const ModalChart: FC<Props> = ({ visible, closeVisible, record, schedules }) => {
  const [dataChart, setDateChart] = useState<GetUserHealthResponse>();
  const [newDay, setNewDay] = useState<string | Date | null>(null);
  const [dataCSVChart, setDataCSVChart] = useState<any>([]);

  const { Text } = Typography;
  const handleClose = () => {
    setDateChart(undefined);
    closeVisible(false);
    setNewDay(null);
  };

  const options: ChartOptions<any> = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        bodyColor: '#000',
        padding: 10,
        yAlign: 'bottom',
        displayColors: false,
        titleColor: '#000',
        footerColor: '#000',
        backgroundColor: 'rgba(255,255,255)',
        borderColor: 'rgb(172, 170, 170)',
        borderWidth: 0.2,
        tooltipFontSize: '16px',
        titleFontColor: 'rgba(0, 0, 0, 0.87)',
        titleFont: {
          size: 12,
          weight: 'normal',
        },
        bodyFont: {
          size: 16,
        },
        footerFont: {
          size: 12,
          weight: 'normal',
        },
        callbacks: {
          title: () => {
            return null;
          },
          afterTitle: (tooltipItems: [{ label: number }]) => {
            const datasets: any = tooltipItems.find((value: any) => value.dataset.type);
            if (datasets?.dataset.type === 'line') {
              return `心拍数（１分間） ${datasets?.label}`;
            } else {
              const h = tooltipItems.find((value) => value.label);
              return `歩数(累計) ${h?.label}`;
            }
          },
          footer: (tooltipItems: [{ raw: { z: string } }, { dataset: { type: string } }]) => {
            const datasets: any = tooltipItems.find((value: any) => value.dataset.type);
            if (datasets?.dataset.type === 'line') {
              return null;
            } else {
              const v: any = tooltipItems.find((value: any) => value.raw.z);
              return `平均歩数 ${v?.raw.z}歩`;
            }
          },
          label: (tooltipItems: {
            dataset: {
              type: string;
              line: { type: string };
              data: [{ x: string; y: string }];
            };
            raw: { y: number; z: number };
            label: number;
          }) => {
            if (tooltipItems.dataset.type === 'line') {
              let label1 = `${tooltipItems.raw.y}回`;
              return [label1];
            } else {
              let label1 = `${tooltipItems.raw.y}歩`;
              return [label1];
            }
          },
        },
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
        beginAtZero: true,
        type: 'time',
        time: {
          unit: 'hour',
          unitStepSize: 1,
          tooltipFormat: 'HH:mm',
          displayFormats: {
            hour: 'HH:mm',
            max: 24,
            min: 0,
          },
        },
      },
      count: {
        grid: {
          display: false,
        },
        position: 'right',
        color: '#fff',
      },
      sales: {
        grid: {
          borderDash: [8, 4],
        },
        position: 'left',
      },
    },
  };

  const enterTime = dayjs(dataChart?.enter_time).format('H');
  const leaveTime = dayjs(dataChart?.leave_time).format('H');
  const day = dayjs(dataChart?.enter_time).format('YYYY/MM/DD');

  const dataLine = useMemo(() => {
    // 2025/04/30 Leading Win 匠対応一覧#17 start
    return [];
    // let health = 0;
    // const func = ({ h }: { h: number }) => {
    //   if (h >= +enterTime && h <= +leaveTime) {
    //     const healthCount = dataChart?.heartbeat_count[health];
    //     health += 1;
    //     return healthCount;
    //   }
    //   return null;
    // };
    // if (!dataChart) {
    //   return [];
    // }
    // let arr = [];

    // for (let h = 0; h <= 24; h++) {
    //   for (let m = 0; m <= 59; m += 5) {
    //     if (m < 10) {
    //       arr.push({
    //         x: `${day} ${h < 10 ? `0${h}` : h}:0${m}`,
    //         y: func({ h }),
    //       });
    //     } else if (m === 59) {
    //       arr.push({
    //         x: `${day} ${h < 10 ? `0${h}` : h}:59:00`,
    //         y: func({ h }),
    //       });
    //     } else {
    //       arr.push({
    //         x: `${day} ${h < 10 ? `0${h}` : h}:${m}`,
    //         y: func({ h }),
    //       });
    //     }
    //   }
    // }
    // return arr;
    // 2025/04/30 Leading Win 匠対応一覧#17 end
  }, [dataChart, day, enterTime, leaveTime]);

  const houseDay = useCallback(() => {
    let result = [];
    for (let h = 0; h <= 24; h++) {
      result.push(`${day} ${h < 10 ? `0${h}` : h}:00`);
    }
    return result;
  }, [day]);

  const dataBar = useMemo(() => {
    // 2025/04/30 Leading Win 匠対応一覧#17 start
    return [];

    // let step = 0;
    // let step1 = 0;
    // const func2 = ({ h }: { h: number }) => {
    //   if (h >= +enterTime && h <= +leaveTime) {
    //     const steps = lodash.chunk(dataChart?.steps, 12);
    //     const newStep = steps.map((value) => {
    //       const crt = value.map((v) => +v);
    //       return Math.round(
    //         crt.reduce((a: number, b: number) => Number(a) + Number(b)) / crt.length
    //       );
    //     });
    //     const accumulate = (arr: number[]) =>
    //       arr.map(
    //         (
    //           (sum) => (value: number) =>
    //             (sum += value)
    //         )(0)
    //       );
    //     const stepCount = accumulate(newStep)[step1];
    //     step1 += 1;
    //     return stepCount;
    //   }
    //   return null;
    // };
    // const func3 = ({ h }: { h: number }) => {
    //   if (h >= +enterTime && h <= +leaveTime) {
    //     const steps = lodash.chunk(dataChart?.steps, 12);
    //     const newStep = steps.map((value) => {
    //       const crt = value.map((v) => +v);
    //       return Math.round(
    //         crt.reduce((a: number, b: number) => Number(a) + Number(b)) / crt.length
    //       );
    //     });
    //     const stepCount = newStep[step];
    //     step += 1;
    //     return stepCount;
    //   }
    //   return null;
    // };
    // return dataLine.map((item) => {
    //   const format = dayjs(item.x).format('H');
    //   const findX = houseDay().find((i) => i === item.x);
    //   if (findX) {
    //     return { x: item.x, y: func2({ h: Number(format) }), z: func3({ h: Number(format) }) };
    //   }
    // });
    // 2025/04/30 Leading Win 匠対応一覧#17 end
  }, [dataChart, dataLine, enterTime, houseDay, leaveTime]);

  const dataItem: ChartData<any> = {
    datasets: [
      {
        label: '歩数',
        type: 'bar',
        data: dataBar,
        backgroundColor: 'rgb(28, 75, 140)',
        order: 2,
        barThickness: 20,
      },
      {
        label: '心拍数',
        type: 'line',
        data: dataLine,
        yAxisID: 'sales',
        pointRadius: 0.5,
        borderWidth: 2,
        radius: 0,
        borderColor: 'rgb(239, 153, 26)',
        order: 1,
      },
    ],
  };

  const dataCsv = useMemo(
    () =>
      dataCSVChart &&
      dataCSVChart.map((dataCsv: dataCsvProps) => ({
        date: dataCsv?.date,
        name: dataCsv?.user_name,
        workType: dataCsv?.work_type_name,
        company: dataCsv?.cooperator_company_name,
        admission: dataCsv?.enter_time ? moment(dataCsv?.enter_time).format('HH:mm') : '',
        exit_time: dataCsv?.leave_time ? moment(dataCsv?.leave_time).format('HH:mm') : '',
        // 2025/04/30 Leading Win 匠対応一覧#17 start
        // declared: dataCsv?.body_temperature,
        // pressure: dataCsv?.blood_pressure_min,
        // hypertension: dataCsv?.blood_pressure_max,
        // 2025/04/30 Leading Win 匠対応一覧#17 end
      })),
    [dataCSVChart]
  );

  const headers = [
    { label: '日付', key: 'date' },
    { label: '作業員名', key: 'name' },
    { label: '工種', key: 'workType' },
    { label: '所属業者', key: 'company' },
    { label: '入場時刻', key: 'admission' },
    { label: '退場時刻', key: 'exit_time' },
    // 2025/04/30 Leading Win 匠対応一覧#17 start
    // { label: '申告体温', key: 'declared' },
    // { label: '申告最低血圧', key: 'pressure' },
    // { label: '申告最高血圧', key: 'hypertension' },
    // 2025/04/30 Leading Win 匠対応一覧#17 end
  ];

  useEffect(() => {
    if (!schedules) return;
    schedules[0]?.date && setNewDay(dayjs(schedules[0]?.date).format('YYYY-MM-DD'));
  }, [schedules]);

  const fetchDataHealthChart = useCallback(
    async (date) => {
      if (!record?.user_id || schedules.length === 0 || !newDay) return;
      try {
        const { data } = await workerService.getUserHealthChart({
          user_id: +record.user_id,
          working_day: dayjs(date).format('YYYY/MM/DD').toString(),
        });
        setDateChart(data);
      } catch (e) {
        console.error(e);
      }
    },
    [newDay, record, schedules]
  );

  useEffect(() => {
    newDay && fetchDataHealthChart(newDay);
  }, [fetchDataHealthChart, newDay]);

  const handleChange = (value: any) =>
    value.domEvent?.target?.innerText && setNewDay(() => value.domEvent.target.innerText);

  const setDate: any = [];
  schedules.map((value, index) => {
    return setDate.push(dayjs(value.date).format('YYYY/MM/DD'));
  });
  const dataDate: string[] = Array.from(new Set(setDate));
  useEffect(() => {
    if (dataCSVChart && csvInstance && csvInstance.current && csvInstance.current.link) {
      setTimeout(() => {
        csvInstance.current.link.click();
        setDataCSVChart([]);
      }, 1500);
    }
  }, [dataCSVChart]);
  const csvInstance = useRef<any | null>(null);
  return (
    <ModalStyle>
      <Modal
        title={
          <HeaderStyledChart>
            <div style={{ display: 'flex', alignItems: 'center' }} onClick={handleClose}>
              <img src={arrowLeft} alt="arrowLeft" />
              <div>作業員詳細</div>
            </div>
            {dataCsv.length > 0 && (
              <CSVLink
                filename={`${dataChart?.user_name}_${dayjs(dataCSVChart[0]?.date).format(
                  'YYYYMM'
                )}.csv`}
                data={dataCsv}
                headers={headers}
                ref={csvInstance}
              />
            )}
            <ButtonCsv
              disabled={!dataChart || dataDate.length <= 0}
              onClick={async () => {
                const dateFrom = dayjs(newDay).startOf('month').format('YYYY-MM-DD');
                const dateFromStart = dayjs(newDay).endOf('month').format('YYYY-MM-DD');
                const dataDate = Array.from(
                  new Set(
                    schedules.map((value) => {
                      return value?.date && dayjs(value.date).format('YYYY-MM-DD');
                    })
                  )
                );
                const listDateBetween = dataDate.filter((item) =>
                  // dayjs(item).isBetween(dateFrom, dateFromStart)
                  dayjs(item).isBetween(dateFrom, dateFromStart, null, '[]')
                );
                const dataSvg: any[] = await Promise.all(
                  listDateBetween.map(async (date: any) => {
                    if (record?.user_id && date) {
                      const { data } = await workerService.getUserHealthChart({
                        user_id: +record.user_id,
                        working_day: date,
                      });
                      return { ...data, date };
                    }
                  })
                );
                setDataCSVChart(() => dataSvg);
              }}
            >
              今月の勤怠情報CSV出力
            </ButtonCsv>
          </HeaderStyledChart>
        }
        visible={visible}
        footer={false}
        width={960}
        className="modal-chart"
      >
        <ChartContentStyled>
          {dataChart ? (
            <Row>
              <Col span={4} className="menu-left" style={{ height: 500, overflow: 'auto' }}>
                <div className="text-left">日付</div>
                <Menu className="menu" defaultSelectedKeys={['1']}>
                  {dataDate.map((value: string, index: number) => (
                    <Menu.Item className="menu-time-chart" key={index + 1} onClick={handleChange}>
                      {value}
                    </Menu.Item>
                  ))}
                </Menu>
              </Col>
              <Col span={19} className="text-item-col">
                <RowText>
                  <Col span={5} className="text-item">
                    作業員名
                  </Col>
                  <Col span={4} className="text-item">
                    工種
                  </Col>
                  <Col span={7} className="text-item">
                    所属業者
                  </Col>
                  <Col span={4} className="text-item">
                    入場時刻
                  </Col>
                  <Col span={4} className="text-item">
                    退場時刻
                  </Col>
                  {/* 2025/04/30 Leading Win 匠対応一覧#17 start */}
                  {/*
									 <Col span={3} className="text-item">
                    申告体温
                  </Col>
                  <Col span={4} className="text-item">
                    申告血圧
                  </Col> 
									*/}
                  {/* 2025/04/30 Leading Win 匠対応一覧#17 end */}
                </RowText>
                <>
                  <RowText>
                    <Col className="row-text" span={5}>
                      {dataChart?.user_name}
                    </Col>
                    <Col className="row-text" span={4}>
                      {dataChart?.work_type_name}
                    </Col>
                    <Col className="row-text" span={7}>
                      {dataChart?.cooperator_company_name}
                    </Col>
                    <Col className="row-text" span={4}>
                      {dataChart?.enter_time !== null
                        ? moment(dataChart?.enter_time).format('HH:mm')
                        : ''}
                    </Col>
                    <Col className="row-text" span={4}>
                      {dataChart?.leave_time !== null
                        ? moment(dataChart?.leave_time).format('HH:mm')
                        : ''}
                    </Col>
                    {/* 2025/04/30 Leading Win 匠対応一覧#17 start */}
                    {/* 
										<Col className="row-text" span={3}>
                      {dataChart?.body_temperature}
                    </Col>
                    <Col className="row-text" span={4}>
                      {dataChart?.blood_pressure_min} 〜 {dataChart?.blood_pressure_max}
                    </Col> 
										*/}
                    {/* 2025/04/30 Leading Win 匠対応一覧#17 end */}
                  </RowText>
                  <div className="title-chart">
                    <Text strong style={{ marginTop: 16 }}>
                      {/* // 2025/04/30 Leading Win 匠対応一覧#17 start */}
                      {/* 運動量評価 {dataChart?.score} */}
                      運動量評価
                      {/* // 2025/04/30 Leading Win 匠対応一覧#17 end */}
                    </Text>
                    {/* 2023/04/25 Leading Win 「本日の歩数：0歩」非表示化対応 start */}
                    <Text style={{ marginLeft: 16 }}>※現在開発中の機能です。</Text>
                    {/* 2023/04/25 Leading Win 「本日の歩数：0歩」非表示化対応 end */}
                    <div className="label-chart">
                      <span className="chart-line">
                        <svg
                          stroke="#EF991A"
                          fill="none"
                          strokeWidth="5"
                          viewBox="0 0 24 24"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          height="1em"
                          width="1em"
                          xmlns="http://www.w3.org/2000/svg"
                          style={{ marginRight: 8 }}
                        >
                          <line x1="-1" y1="12" x2="30" y2="12" />
                        </svg>
                        <span style={{ alignSelf: 'center', color: '#0000000' }}>心拍数</span>
                      </span>
                      <span className="chart-bar">
                        <svg
                          stroke="#1C4B8C"
                          fill="currentColor"
                          strokeWidth="20"
                          viewBox="0 0 16 16"
                          height="1em"
                          width="1em"
                          xmlns="http://www.w3.org/2000/svg"
                          style={{ marginRight: 8, height: 16 }}
                        >
                          <path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2z" />
                        </svg>
                        <span style={{ color: '#0000000', lineHeight: '14px' }}>歩数</span>
                      </span>
                    </div>
                  </div>
                  <div>
                    <span className="text-x">心拍</span>
                    <span className="text-y">歩数</span>
                  </div>
                  <div style={{ height: 350 }}>
                    <Bar data={dataItem} options={options} />
                  </div>
                </>
              </Col>
            </Row>
          ) : (
            <div
              className="example-spin"
              style={{
                height: 490,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Spin
                size="large"
                indicator={
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <span className="ant-spin-dot ant-spin-dot-spin" style={{ fontSize: 28 }}>
                      <i className="ant-spin-dot-item" />
                      <i className="ant-spin-dot-item" />
                      <i className="ant-spin-dot-item" />
                      <i className="ant-spin-dot-item" />
                    </span>
                    <div style={{ marginTop: 60, textAlign: 'center' }}>
                      <div style={{ fontSize: 18, fontWeight: 'bold', width: '500px' }}>
                        データを取得しています...
                      </div>
                      <div style={{ fontSize: 14, marginTop: 20 }}>
                        ※取得に時間がかかる場合は、対象データが存在しない可能性があります。
                      </div>
                      <div style={{ fontSize: 14 }}>
                        （まだ一度も現場に入場していないことが考えられます）
                      </div>
                    </div>
                  </div>
                }
              />
            </div>
          )}
        </ChartContentStyled>
      </Modal>
    </ModalStyle>
  );
};

export default ModalChart;
